import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import { apiGetAllZones } from "api/zones";
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles } from "utils/dialogStyles";

const PrintDialog = ({ open, onClose, onPrint }) => {
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "warning" });
  const [filters, setFilters] = useState({
    zonharta: "",
    statusakaun: "",
  });
  const [zones, setZones] = useState([]);
  const [loadingZones, setLoadingZones] = useState(true);

  // Fetch zones on component mount
  useEffect(() => {
    const fetchZones = async () => {
      try {
        setLoadingZones(true);
        const response = await apiGetAllZones(1, 100);
        if (response.data) {
          setZones(response.data);
        }
      } catch (error) {
        setSnackbar({ open: true, message: "Gagal memuatkan zon.", severity: "error" });
        setZones([]);
      } finally {
        setLoadingZones(false);
      }
    };

    if (open) {
      fetchZones();
    }
  }, [open]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePrint = () => {
    onPrint(filters);
    handleClose();
  };

  const handleClose = () => {
    setFilters({
      zonharta: "",
      statusakaun: "",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ ...dialogHeaderStyles.profile, py: 1.5, px: 2 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ color: "#fff" }}>Cetak Laporan Penyewa</Typography>
          <Button onClick={handleClose} color="inherit" size="small">
            <CloseIcon />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mt={2} mb={2}>
          Pilih kriteria untuk mencetak senarai penyewa:
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#ffffffff",
                  fontSize: "0.875rem",
                  p: 1.2,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.875rem",
                },
              }}
            >
              <InputLabel id="print-zon-label">Zon</InputLabel>
              <Select
                labelId="print-zon-label"
                id="print-zon"
                label="Zon"
                name="zonharta"
                value={filters.zonharta}
                onChange={handleFilterChange}
              >
                <MenuItem value="">
                  <em>Semua Zon</em>
                </MenuItem>
                {loadingZones ? (
                  <MenuItem value="" disabled>
                    Loading...
                  </MenuItem>
                ) : (
                  zones.map((zone) => (
                    <MenuItem key={zone.id} value={zone.zon}>
                      {zone.zon}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#ffffffff",
                  fontSize: "0.875rem",
                  p: 1.2,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.875rem",
                },
              }}
            >
              <InputLabel id="print-status-label">Status Akaun</InputLabel>
              <Select
                labelId="print-status-label"
                id="print-status"
                label="Status Akaun"
                name="statusakaun"
                value={filters.statusakaun}
                onChange={handleFilterChange}
              >
                <MenuItem value="">
                  <em>Semua Status</em>
                </MenuItem>
                <MenuItem value="Aktif">Aktif</MenuItem>
                <MenuItem value="Tidak Aktif">Tidak Aktif</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={handlePrint}
          variant="contained"
          size="small"
          sx={buttonStyles.primary}
          startIcon={<PrintIcon />}
        >
          CETAK
        </Button>
        <Button
          onClick={handleClose}
          variant="contained"
          size="small"
          sx={buttonStyles.cancel}
        >
          BATAL
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PrintDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
};

export default PrintDialog;
